import React from "react";

const CONTACT_HREF =
  "mailto:fed@moonscroll.ai?subject=Video%20generation%20beta&body=Hi%2C%20I%27d%20like%20to%20beta%20test%20video%20generation.";

/**
 * Shown when the user can open Videos but does not have the videos feature flag.
 */
const VideoAccessEmptyState = () => {
  return (
    <div className="text-center py-16">
      <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-theme-secondary flex items-center justify-center">
        <svg
          className="w-10 h-10 text-theme-text opacity-30"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M15.75 10.5l4.72-4.72a.75.75 0 011.28.53v11.38a.75.75 0 01-1.28.53l-4.72-4.72M4.5 18.75h9a2.25 2.25 0 002.25-2.25v-9a2.25 2.25 0 00-2.25-2.25h-9A2.25 2.25 0 002.25 7.5v9a2.25 2.25 0 002.25 2.25z"
          />
        </svg>
      </div>
      <h3 className="text-xl font-semibold text-theme-text mb-2">Video generation</h3>
      <p className="text-theme-text opacity-60 max-w-md mx-auto mb-2">
        Turn a script into a video, right from Moonscroll.
      </p>
      <p className="text-theme-text opacity-60 max-w-md mx-auto mb-6 text-sm">
        This is in beta. Get in touch if you want to try video generation.
      </p>
      <a
        href={CONTACT_HREF}
        className="inline-flex px-4 py-2 rounded-md bg-theme-primary text-theme-button hover:opacity-90"
        style={{ backgroundColor: "var(--theme-primary)", color: "var(--theme-button-text)" }}
      >
        Contact us
      </a>
    </div>
  );
};

export default VideoAccessEmptyState;
